// Angular Files
import { Component, Input } from '@angular/core';

// Component Files
import { ScheduledItemViewModel } from './scheduled-payment-details.models';

@Component({
    selector: 'teller-online-scheduled-payment-details',
    templateUrl: './scheduled-payment-details.component.html',
    styleUrls: ['./scheduled-payment-details.component.scss'],
    host: {
        class: 'scheduled-payment-details'
    },
    standalone: false
})
export class TellerOnlineScheduledPaymentDetailsComponent {
    // Public variables
    @Input() public item: ScheduledItemViewModel;

    @Input() public showTitle: boolean = false;

    @Input() public showHeader: boolean = false;

    public getTotalAmount(): number {
        return (this.item?.amount ?? 0) + (this.item?.convenienceFee ?? 0);
    }
}
